import type { RouterOutput } from '../types';

type ContentItem = RouterOutput['contents']['findAll'][number];

let contents = $state<Record<string, ContentItem>>({});

export function useContentsStore() {
	return {
		get value() {
			return contents;
		},
		set value(value: Record<string, ContentItem>) {
			contents = value;
		}
	};
}

export function setContents(c: Record<string, ContentItem>) {
	contents = c;
}
